// Stepts for homepage
const careerSiteSteps = [
{
    element: ".page-1",
    popover: {
        title: '🥳 <br>Kariérna stránka',
        description: '<b>Tu môžete pripraviť stránky jednoducho ako vo Worde.</b> Ak už máte vlastnú kariérnu stránku, nemusíte tejto sekcii venovať pozornosť.',
        position: 'bottom-left',
        showButtons: true,         // Do not show control buttons in footer
    },
},
{
    element: ".guide-step-carreersite-1",
    popover: {
        title: ' ',
        description: 'Tu môžete zadať firemnú farbu, ktorá sa bude objavovať naprieč celou kariérnou stránkou.',
        position: 'bottom-right',
        showButtons: true,         // Do not show control buttons in footer
    },
},
{
    element: ".body-container",
    popover: {
        title: ' ',
        description: 'Obsah stránky je možné editovať kliknutím priamo do textu ako vo Worde.',
        position: 'top',
        showButtons: true,
    },
},
{
    element: ".footer",
    popover: {
        title: ' ',
        description: 'Zoznam všetkých aktuálnych otvorených pozícii je na kariérnej stránke umiestnený tu.',
        position: 'top',
        showButtons: true,         // Do not show control buttons in footer
    },
},
{
    element: ".footer-container",
    popover: {
        title: ' ',
        description: '<b>Potrebujete pomôcť?</b> Radi pre vás natočíme video rozhovor s vaším CEO alebo tour po firme, ktorá kandidátov bližšie zoznámi s tým, ako to vo firme chodí. Kontaktujte nás.',
        position: 'top',
        showButtons: true,         // Do not show control buttons in footer
    },
},
{
    element: "#start-guide",
    popover: {
        title: '🥳 <br>Hotovo!',
        description: '<b>Nezabudni, že do sprievodcu sa môžeš kedykoľvek vrátiť</b> kliknutím na ikonu lode Onboardio vľavo dole.<br>',
        position: 'top',
        showButtons: true,         // Do not show control buttons in footer
        nextBtnText: 'Rozumiem',
        doneBtnText: 'Rozumiem',        // Next button text for this step
    },
},

]



export default careerSiteSteps